import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import HeaderPortal from '../layout/HeaderPortal';
import ReportsCardContainer from './ReportsCardContainer';

export const ReportsRoute = () => {
  return (
    <React.Fragment>
      <ReportsCardContainer />
      <HeaderPortal />
    </React.Fragment>
  );
};

ReportsRoute.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(ReportsRoute);
